<template>
  <StorageCockpit />
</template>

<script>
import StorageCockpit from "../ywhc/v2/StorageCockpit.vue";

export default {
  name: "CockpitWarm",
  components: {
    StorageCockpit,
  },
};
</script>
